let SnakeToSpace = function () {
  return function(input, param){
    if(angular.isDefined(input)){
      return input.replace(/_/g," ").toLowerCase();
    }
  }
}
export default SnakeToSpace;



// WEBPACK FOOTER //
// ./client/app/common/filters/snakeToSpaceService/snakeToSpace.filter.js